import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../usercontrols/loader/loader";
import { getUserFullName, getUserRoles } from "../../../utils/Functions";
import {
  hasUserPortalAccess,
  isLoggedIn,
  loginSuccess,
} from "../../../reducers/authSlice";
import { useCallback, useEffect } from "react";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RootRouter from "./RootRouter";

const RootRouterContainer = () => {
  const props = useAuth0();
  const dispatch = useAppDispatch();

  const { isAuthenticated, isLoading, user } = props;
  const isUserLoggedIn = useAppSelector(isLoggedIn);
  const userHasPortalAccess = useAppSelector(hasUserPortalAccess);

  const getUserDetails = useCallback(async () => {
    let userFullName = await getUserFullName(props);
    let roles = await getUserRoles(props);

    dispatch(loginSuccess({ roles: roles, userName: userFullName }));
  }, [dispatch, props]);

  useEffect(() => {
    if (user && isAuthenticated && !isLoading) {
      getUserDetails();
    }
  }, [dispatch, getUserDetails, isAuthenticated, isLoading, props, user]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <RootRouter
      isAuthenticated={isAuthenticated}
      isUserLoggedIn={isUserLoggedIn}
      userHasPortalAccess={userHasPortalAccess}
    />
  );
};

export default RootRouterContainer;
